import React from "react";
import { Tabs } from "antd";

import Body from "./Body";
import Headers from "./Headers";

const SettingUrl = ({ data, updateData }) => {
  const items = [
    {
      key: "1",
      label: `Headers`,
      children: <Headers updateData={updateData} data={data} />,
    },
    {
      key: "2",
      label: `Body`,
      children: <Body updateData={updateData} data={data} />,
    },
  ];
  return (
    <div style={{ textAlign: "left" }}>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default SettingUrl;
